"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cetusTestnetSDKOptions = void 0;
exports.cetusTestnetSDKOptions = {
    fullRpcUrl: "https://fullnode.testnet.sui.io",
    swapCountUrl: "https://api-sui.devcetus.com/v2/sui/swap/count",
    simulationAccount: {
        address: "0x4260738f0f7341adc79a8edaa62f8a4681ebd27c595aecab1f322f47bfc52c5e",
    },
    cetus_config: {
        package_id: "0xf5ff7d5ba73b581bca6b4b9fa0049cd320360abd154b809f8700a8fd3cfaf7ca",
        published_at: "0xf5ff7d5ba73b581bca6b4b9fa0049cd320360abd154b809f8700a8fd3cfaf7ca",
        config: {
            coin_list_id: "0x257eb2ba592a5480bba0a97d05338fab17cc3283f8df6998a0e12e4ab9b84478",
            launchpad_pools_id: "0xdc3a7bd66a6dcff73c77c866e87d73826e446e9171f34e1c1b656377314f94da",
            clmm_pools_id: "0x26c85500f5dd2983bf35123918a144de24e18936d0b234ef2b49fbb2d3d6307d",
            admin_cap_id: "0x1a496f6c67668eb2c27c99e07e1d61754715c1acf86dac45020c886ac601edb8",
            global_config_id: "0xe1f3db327e75f7ec30585fa52241edf66f7e359ef550b533f89aa1528dd1be52",
            coin_list_handle: "0x3204350fc603609c91675e07b8f9ac0999b9607d83845086321fca7f469de235",
            launchpad_pools_handle: "0xae67ff87c34aceea4d28107f9c6c62e297a111e9f8e70b9abbc2f4c9f5ec20fd",
            clmm_pools_handle: "0xd28736923703342b4752f5ed8c2f2a5c0cb2336c30e1fed42b387234ce8408ec",
        },
    },
    clmm_pool: {
        package_id: "0x0868b71c0cba55bf0faf6c40df8c179c67a4d0ba0e79965b68b3d72d7dfbf666",
        published_at: "0x084dbc14f8f6b50e4e1d6828ebf1f93fd1b1d2502b121bc787937893793417b0",
        config: {
            pools_id: "0xc090b101978bd6370def2666b7a31d7d07704f84e833e108a969eda86150e8cf",
            global_config_id: "0x6f4149091a5aea0e818e7243a13adcfb403842d670b9a2089de058512620687a",
            global_vault_id: "0xf3114a74d54cbe56b3e68f9306661c043ede8c6615f0351b0c3a93ce895e1699",
            admin_cap_id: "0xa456f86a53fc31e1243f065738ff1fc93f5a62cc080ff894a0fb3747556a799b",
            partners_id: "0xb1cefb6de411213a1cfe94d24213af2518eff3d51267fb95e35d11aa77fc9b5f",
        },
    },
    integrate: {
        package_id: "0x8627c5cdcd8b63bc3daa09a6ab7ed81a829a90cafce6003ae13372d611fbb1a9",
        published_at: "0xd55d88490e28ef68d83d2fe7862909dfcef6e43a2f50403f3a461c4678e274f1",
    },
    deepbook: {
        package_id: "0x000000000000000000000000000000000000000000000000000000000000dee9",
        published_at: "0x000000000000000000000000000000000000000000000000000000000000dee9",
    },
    deepbook_endpoint_v2: {
        package_id: "0xa34ffca2c6540e1ca9e53963ab43e7b1eed7b82e37696c743bb7c6179c15dfa6",
        published_at: "0xa34ffca2c6540e1ca9e53963ab43e7b1eed7b82e37696c743bb7c6179c15dfa6",
    },
    aggregatorUrl: "https://api-sui.devcetus.com/router",
};
//# sourceMappingURL=testnet_config.js.map